/*---------------------------------------------------------------
 ?? Project: Ring2All Platform
 ????? Author: Rodrigo Cuadra
 ?? Company: Ring2All LLC
 ?? File: components\SystemVarsFieldWithReset.tsx
 ??? Created: 2026-05-02
 ?? Description:
    Implementation of the System Vars module.
----------------------------------------------------------------*/


import React from 'react';
import { RotateCcw } from 'lucide-react';
import { SimpleTooltip } from '../../../components/ui/SimpleTooltip';
import { useI18n } from '../../../hooks/useI18n';

interface Props {
    isModified: boolean;
    onResetToDefault: () => void;
    children: React.ReactNode;
}

export function SystemVarsFieldWithReset({ isModified, onResetToDefault, children }: Props) {
    const { t } = useI18n();
    return (
        <div className="flex items-center gap-2">
            <div className="flex-1">{children}</div>
            {isModified && (
                <div className="flex items-center gap-1 flex-shrink-0">
                    <SimpleTooltip content={t('systemVars.indicators.modifiedFromDefault')}>
                        <div className="h-2 w-2 bg-amber-500 rounded-full animate-pulse" />
                    </SimpleTooltip>
                    <SimpleTooltip content={t('systemVars.indicators.resetToDefault')}>
                        <button type="button" onClick={onResetToDefault} className="p-1 hover:bg-blue-50 dark:hover:bg-blue-950 rounded transition-colors">
                            <RotateCcw className="h-4 w-4 text-blue-600 dark:text-blue-400" />
                        </button>
                    </SimpleTooltip>
                </div>
            )}
        </div>
    );
}
